import type { LevelDefinition } from './Level.ts';

/**
 * Level 1 — the loop, and nothing else.
 *
 * One magnet, one baffle, an open arena. Drop a positive magnet near the goal, press
 * Start, and the fluid crosses the board and slides around the baffle on its way. The
 * only thing to learn is that a magnet is a destination and the walls do the steering.
 */
export const level01: LevelDefinition = {
  id: 'level01',
  name: 'Attraction',
  hint: 'Place a magnet, then press Start. Fluid falls towards a positive magnet.',
  magnetsAvailable: 1,
  fluid: {
    amount: 380,
    source: { x: 320, y: 450 },
    radius: 44,
  },
  goal: { x: 700, y: 1140, radius: 120, type: 'fluid', fraction: 0.5 },
  walls: [
    // Arena.
    { type: 'segment', x1: 150, y1: 260, x2: 850, y2: 260, thickness: 26 },
    { type: 'segment', x1: 850, y1: 260, x2: 850, y2: 1340, thickness: 26 },
    { type: 'segment', x1: 850, y1: 1340, x2: 150, y2: 1340, thickness: 26 },
    { type: 'segment', x1: 150, y1: 1340, x2: 150, y2: 260, thickness: 26 },

    // One baffle, so the crossing is not a straight line and the fluid has to hug
    // something on its way past.
    { type: 'segment', x1: 150, y1: 800, x2: 560, y2: 800, thickness: 26 },
  ],
};
